// Backend
export const DEFAULT_BACKEND_SIMPLE_NEST_PROJECT_NAME = 'miregen-nest-app';
export const BACKEND_SIMPLE_NEST_REPO =
  'https://gitlab.com/miregen-cli-templates/miregen-nestjs-template/-/archive/main/miregen-nestjs-template-main.tar.gz';

// Frontend
export const DEFAULT_FRONTEND_NEXT_LANDING_HEROUI_PROJECT_NAME = 'miregen-next-landing-heroui';
export const FRONTEND_NEXT_LANDING_HEROUI_REPO = '';

export const DEFAULT_FRONTEND_NEXT_LANDING_SHADCN_PROJECT_NAME = 'miregen-next-landing-shadcn';
export const FRONTEND_NEXT_LANDING_SHADCN_REPO = '';

export const DEFAULT_FRONTEND_NEXT_DOCS_FUMADOCS_PROJECT_NAME = 'miregen-next-docs-fumadocs';
export const FRONTEND_NEXT_DOCS_FUMADOCS_REPO = '';

export const DEFAULT_FRONTEND_NEXT_DASHBOARD_HEROUI_PROJECT_NAME = 'miregen-next-dashboard-heroui';
export const FRONTEND_NEXT_DASHBOARD_HEROUI_REPO = '';

export const DEFAULT_FRONTEND_NEXT_DASHBOARD_SHADCN_PROJECT_NAME = 'miregen-next-dashboard-shadcn';
export const FRONTEND_NEXT_DASHBOARD_SHADCN_REPO = '';

// Mobile
export const DEFAULT_MOBILE_FLUTTY_TEMPLATE_PROJECT_NAME = 'miregen-flutty-template';
export const MOBILE_FLUTTY_TEMPLATE_REPO = '';

export const DEFAULT_MOBILE_MIREGMA_TEMPLATE_PROJECT_NAME = 'miregen-miregma-template';
export const MOBILE_MIREGMA_TEMPLATE_REPO = '';
